/* js/fixed-header.js */

$(window).scroll( function() {
    var value = $(this).scrollTop();
    if ( value > 50 ) {
        $(".mainnav__content").css("opacity", "0");
        $(".mainnav__edge").css("opacity", "0");
        $(".mainnav").css("background", "transparent");
        $(".fixed-header").css("z-index", "550");
    } else {
        $(".mainnav__content").css("opacity", "1");
        $(".mainnav__edge").css("opacity", "1");
        $(".mainnav").css("background", "#1CA0AA");
        $(".fixed-header").css("z-index", "450");
    }
});
